import { CustomTextModel, CustomTextService } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { StudyGroupsCapabilityConfiguration } from '../../study_groups_configuration';
import { StudyGroupModalService } from '../study_groups_modal_service';

export class StudyGroupEmailingModalController {
  private isDesktop: boolean;
  private applyDesktopStyle?: true;
  private applyMobileStyle: boolean;
  private customEmailInstr: string =
    'You will be taken to an external email application to compose and send this email. Before you send the email, please be mindful about what you communicate to other students.';

  constructor(
    private ngStudyGroupModalService: StudyGroupModalService,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration,
    private ngCustomTextService: CustomTextService,
    private ngCustomTextModel: CustomTextModel
  ) {}

  $onInit() {
    this.isDesktop = PlatformUtility.isDesktop();
    this.applyDesktopStyle = !this.ngStudyGroupsCapabilityConfiguration.config.isMobile || undefined;
    this.applyMobileStyle = this.ngStudyGroupsCapabilityConfiguration.config.isMobile;
    this.getCustomEmailInstr();
  }

  getCustomEmailInstr() {
    if (_4.isEmpty(this.ngCustomTextModel.read())) {
      this.ngCustomTextService.loadCustomText().then(() => {
        this.setCustomEmailInstr();
      });
    } else {
      this.setCustomEmailInstr();
    }
  }

  setCustomEmailInstr() {
    this.customEmailInstr =
      _4.get(_4.find(this.ngCustomTextModel.read(), { nk: 'STUDY_BUDDY_INSTR_EMAIL' }), 'text') ||
      this.customEmailInstr;
  }

  closeModal(): void {
    this.ngStudyGroupModalService.hideEmailingModal();
  }

  confirmEmailing(): void {
    this.ngStudyGroupModalService.sendEmail();
  }
}

export class StudyGroupEmailingModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-study-groups/src/modals/study_group_emailing_modal/study_group_emailing_modal.html';
  public controller: any = StudyGroupEmailingModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/modals/study_group_emailing_modal/study_group_emailing_modal.ts